import "./index.0.css";
const __script_base__ = {
  name: 'WCol',
  props: {
    mode: {
      type: String,
      default: 'normal'
    },
    width: {
      type: String,
      default: ''
    },
    weight: {
      type: Number,
      default: 1
    },
    alignItems: {
      type: String,
      default: 'stretch'
    },
    justifyContent: {
      type: String,
      default: 'flex-start'
    }
  },
  computed: {
    style() {
      const {
        width,
        weight
      } = this;
      const ans = [`align-items: ${this.alignItems}`, `justify-content: ${this.justifyContent}`];
      if (width) ans.push(`width: ${width}`, `flex-basis: ${width}`);else ans.push(`flex-grow: ${weight}`);
      return ans.join(';');
    }
  }
};
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    ref: "container",
    staticClass: "w-col uc-slotForBlocks",
    class: {
      isEmpty: !this.$slots.default,
      isWidthFixed: !!this.width
    },
    style: _vm.style
  }, [_vm._t("default")], 2);
};
var staticRenderFns = [];
render._withStripped = true;
const __script__ = __script_base__;
export default Object.assign({
  render,
  staticRenderFns,
  _compiled: true
}, {
  "__file": "builtin/components/Col/index.vue"
}, typeof __script__ === 'function' ? __script__.options : __script__);